<template>
  <div>
    <van-field v-model="textValue"
               v-bind="$attrs"
               :name="$attrs.name"
               :rules="rules"
               :required="required"
               :readonly="readonly"
               :is-link="islink"
               @click="show = !show" />
    <van-popup v-model="show"
               get-container="body"
               position="bottom">
      <!-- isSearch:是否模糊查询 -->
      <van-search v-if="isSearch"
                  v-model="searchKey"
                  placeholder="请输入搜索关键词"
                  @input="onSearch"
                  @clear="resetColumns" />
      
      <!-- 单选模式 -->
      <template v-if="!isMultiple">
        <van-picker :columns="columnsData"
                    show-toolbar
                    :value-key="keyValue"
                    :title="$attrs.label"
                    @cancel="canclePop"
                    @confirm="onConfirmSingle">
          <template #option="option">
            {{ option[keyLabel] }}
          </template>
        </van-picker>
      </template>
      
      <!-- 多选模式 -->
      <template v-else>
        <div class="multi-select-container">
          <div class="multi-select-header">
            <div class="multi-select-title">{{ $attrs.label }}</div>
            <div class="multi-select-actions">
              <span @click="selectAll">全选</span>
              <span @click="cancelAll">取消全选</span>
            </div>
          </div>
          <div class="multi-select-content">
            <van-checkbox-group v-model="selectedValues">
              <van-cell-group>
                <van-cell v-for="(item, index) in columnsData" :key="index">
                  <template #title>
                    <van-checkbox :name="item[keyValue]">
                      {{ item[keyLabel] }}
                    </van-checkbox>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
          <div class="multi-select-footer">
            <van-button plain type="default" @click="canclePop">取消</van-button>
            <van-button type="info" @click="onConfirmMultiple">确定</van-button>
          </div>
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    required: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    islink: {
      type: Boolean,
      default: true
    },
    isSearch: {
      type: Boolean,
      default: true,
    },
    columns: {
      type: Array,
    },
    rules: {
      type: Array,
    },
    // 控制单选/多选模式的参数
    isMultiple: {
      type: Boolean,
      default: false
    },
    // 单选模式的值
    selectValue: {
      type: String,
      default: ""
    },
    // 多选模式的值
    selectValues: {
      type: Array,
      default: () => []
    },
    keyValue: {
      type: String,
    },
    keyLabel: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
      textValue: "",
      selectedValues: [],
      searchKey: "",
      copyList: [],
      columnsData: [],
    };
  },
  methods: {
    resetColumns() {
      this.searchKey = "";
      this.columnsData = this.columns;
    },
    canclePop() {
      this.show = !this.show;
      this.resetColumns();
    },
    onSearch() {
      if (!this.searchKey.length) {
        this.columnsData = this.columns;
        return;
      }
      let newArr = [];
      if (this.columnsData.length) {
        newArr = this.columnsData.filter((item) => {
          return item[this.keyLabel].toString().indexOf(this.searchKey) > -1;
        });
      }
      this.columnsData = newArr;
    },
    // 单选确认
    onConfirmSingle(obj) {
      const selectedOption = this.columns.find(item => item[this.keyValue] === obj.value);
      if (selectedOption && selectedOption[this.keyLabel] !== this.textValue) {
        this.textValue = selectedOption[this.keyLabel];
      }
      this.show = false;
      this.$emit('confirm', obj);
    },
    // 多选全选
    selectAll() {
      this.selectedValues = this.columnsData.map(item => item[this.keyValue]);
    },
    // 多选取消全选
    cancelAll() {
      this.selectedValues = [];
    },
    // 多选确认
    onConfirmMultiple() {
      const selectedItems = this.columns.filter(item => 
        this.selectedValues.includes(item[this.keyValue])
      );
      
      this.textValue = selectedItems.map(item => item[this.keyLabel]).join(", ");
      this.show = false;
      this.$emit('confirm', {
        values: this.selectedValues,
        items: selectedItems
      });
    },
    // 格式化单选值
    formatterSingleValue(value) {
      let str = "";
      if (!this.columns.length || !value.length) {
        str = "";
      } else {
        let oArr = this.columns.filter((item) => {
          return item[this.keyValue].toString() == value.toString();
        });
        if (oArr.length > 0) {
          str = oArr[0][this.keyLabel];
        }
      }

      return str;
    },
    // 格式化多选值
    formatterMultiValue(values) {
      if (!this.columns.length || !values || !values.length) {
        return "";
      }
      
      const selectedItems = this.columns.filter(item => 
        values.includes(item[this.keyValue])
      );
      
      return selectedItems.map(item => item[this.keyLabel]).join(", ");
    },
    // 更新显示文本
    updateTextValue() {
      if (this.isMultiple) {
        this.textValue = this.formatterMultiValue(this.selectValues);
      } else {
        this.textValue = this.formatterSingleValue(this.selectValue);
      }
    }
  },
  watch: {
    columns: {
      handler(newValue) {
        this.columnsData = newValue;
        this.copyList = JSON.parse(JSON.stringify(newValue));
        this.updateTextValue();
      },
      deep: true,
      immediate: true,
    },
    selectValue: {
      handler(newValue) {
        if (!this.isMultiple) {
          this.textValue = this.formatterSingleValue(newValue ? newValue : "");
        }
      },
      deep: true,
      immediate: true,
    },
    selectValues: {
      handler(newValue) {
        if (this.isMultiple) {
          this.selectedValues = newValue || [];
          this.textValue = this.formatterMultiValue(newValue);
        }
      },
      deep: true,
      immediate: true,
    },
    isMultiple: {
      handler() {
        this.updateTextValue();
      },
      immediate: true
    }
  },
};
</script>

<style scoped>
.multi-select-container {
  display: flex;
  flex-direction: column;
  height: 50vh;
  max-height: 500px;
}

.multi-select-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
}

.multi-select-title {
  font-size: 16px;
  font-weight: 500;
}

.multi-select-actions {
  font-size: 14px;
  color: #1989fa;
}

.multi-select-actions span {
  margin-left: 10px;
  cursor: pointer;
}

.multi-select-content {
  flex: 1;
  overflow-y: auto;
}

.multi-select-footer {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid #ebedf0;
}

.multi-select-footer .van-button {
  width: 48%;
}
</style>